{
  "api_docs": "Docs de la API",
  "search": "Buscar",
  "accept": "Aceptar",
  "create": "Crear",
  "submit": "Enviar",
  "delete": "Eliminar",
  "cancel": "Cancelar",
  "enable": "Habilitar",
  "deploy": "Desplegar",
  "scan": "Escanear",
  "download": "Descargar",
  "enabled": "Habilitado",
  "disable": "Deshabilitar",
  "disabled": "Deshabilitado",
  "export": "Exportar",
  "open_modal": "Abrir modal",
  "uuid": "UUID",
  "no_items": "No hay elementos",
  "not_applicable": "N/A",
  "requires_permission": "Usted necesita el permiso {permission}. | Usted necesita los siguientes permisos: {permission}",
  "copied_to_clipboard": "¡Copiado al portapapeles!",
  "click_to_reveal": "Haga clic para mostrar.",
  "reset_password": "Restablecer contraseña",
  "unknown": "Desconocido",
  "no_results_found": "No se han encontrado resultados",
  "results": "no hay resultados | 1 resultado | {n} resultados",
  "more_info": "Más información",
  "changes": "Cambios",
  "metadata": "Metadatos",
  "install": "Instalar",
  "manage": "Gestionar",
  "edit": "Editar",
  "trigger": "Activador",
  "never": "Nunca",
  "none": "Ninguna",
  "save": "Guardar",
  "import": "Importar",
  "success": "Exitoso",
  "info": "Info",
  "warning": "Advertencia",
  "danger": "Peligro",
  "reset": "Reiniciar",
  "loading": "Cargando",
  "click_to_upload_image": "Haga clic para subir una nueva imagen",
  "invalid_file_type": "Tipo de archivo no válido",
  "information": "Información",
  "description": "Descripción",
  "at_a_glance": "En un vistazo",
  "settings": "Ajustes",
  "limits": "Límites",
  "announcements": "Anuncios",
  "notifications": "Notificaciones",
  "clear_all": "Limpiar todo",
  "formats": "Formatos:",
  "device_information": "Información del Dispositivo",
  "permissions": "Permisos",
  "lock": "Bloquear",
  "unlock": "Desbloquear",
  "toggle": "Alternar",
  "reinstall": "Reinstalar",
  "suspend": "Suspender",
  "unsuspend": "Dessuspender",
  "users": "Usuarios",
  "allocations": "Asignaciones",
  "database_hosts": "Hosts de Base de Datos",
  "server_databases": "Base de datos del servidor",
  "locations": "Ubicaciones",
  "nests": "Nidos",
  "eggs": "Huevos",
  "nodes": "Nodos",
  "servers": "Servidores",
  "admin": "Admin",
  "support_op": "Soporte Op",
  "something_went_wrong": "Algo salió mal al intentar realizar esta acción.",
  "daemon_connection_exception": "Hubo una excepción al intentar comunicarse con el demonio.",
  "server": {
    "no_servers": "Sin servidores",
    "no_servers_description": "Parece que usted no tiene servidores...",
    "hostname": "Nombre de Host",
    "name": "Nombre",
    "cpu": "CPU",
    "memory": "Memoria",
    "swap": "Swap",
    "disk": "Disco",
    "node": "Nodo",
    "players": "Jugadores",
    "players_amount": "{current} / {max} Jugadores",
    "ip": "IP",
    "manage": "Gestionar",
    "go_to_console": "Ir a la consola",
    "launch_sftp": "Iniciar SFTP",
    "on_node": " en {node}",
    "gamemode": "Modo de juego",
    "version": "Versión",
    "map": "Mapa",
    "resource_usage": "Uso de Recursos",
    "memory_usage": "Uso de Memoria",
    "cpu_usage": "Uso de CPU",
    "status": {
      "unknown": "Desconocido",
      "error": "Error",
      "offline": "Desconectado",
      "online": "En línea",
      "starting": "Iniciando",
      "stopping": "Deteniendo",
      "migrating": "Migración pendiente",
      "installing": "Instalando",
      "failed_install": "Fallo al instalar",
      "suspended": "Suspender",
      "updating": "Actualizando",
      "moving": "Moviendo",
      "creating_backup": "Crear copia de seguridad",
      "deploying_backup": "Desplegando Copia de Seguridad"
    }
  },
  "units": {
    "bytes": "B",
    "kilobytes": "KB",
    "megabytes": "MB",
    "gigabytes": "GB",
    "terabytes": "TB"
  },
  "dates": {
    "minute_abbreviation": "m",
    "minute": "minuto | minutos"
  },
  "labels": {
    "unknown": "Desconocido",
    "latest": "Último",
    "recommended": "Recomendado"
  },
  "languages": {
    "en": "Inglés",
    "ar_SA": "Árabe",
    "cs_CZ": "Checo",
    "da_DK": "Danés",
    "de_DE": "Alemán",
    "en_PT": "Inglés (Pirata)",
    "es_AR": "Español (Argentina)",
    "es_EM": "Español (Moderno)",
    "et_EE": "Estonio",
    "fi_FI": "Finlandés",
    "fr_FR": "Francés",
    "hi_IN": "Hindú",
    "hr_HR": "Húngaro",
    "it_IT": "Italiano",
    "ja_JP": "Japonés",
    "nl_NL": "Holandés",
    "no_NO": "Noruego",
    "pl_PL": "Polaco",
    "pt_BR": "Portugués",
    "ro_RO": "Rumano",
    "ru_RU": "Ruso",
    "ru_UA": "Ucraniano",
    "sv_SE": "Sueco",
    "tr_TR": "Turco",
    "ur_PK": "Urdu",
    "zh_CN": "Chino (simplificado)"
  }
}
